<!--
 * @Author: DY
 * @Date: 2020-04-07 16:57:36
 * @LastEditTime: 2020-07-04 11:19:37
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \JiYun_Mobile_dev\src\views\default\error.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="error">
            <HeaderNav
                header-title="开发中。。。"
                left-icon-name="2"
                right-icon-name="5"
                :extr="{ leftCallBack: onClickLeft }"
            ></HeaderNav>
            <section>
                <p>
                    页面开发中
                </p>
            </section>
        </div>
    </v-touch>
</template>

<script>
import { HeaderNav } from '@/components/';
export default {
    data() {
        return {
            HeaderNav,
        };
    },
    methods: {
        // 返回上级页面
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/home' });
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/home' });
        },
    },
};
</script>

<style lang="stylus" scoped>
.error
    height 100%
    section
        height calc(100% - 44rpx)
        position relative
        p
            position absolute
            top 50%
            transform translateY(-10%)
            width 100%
            height 100%
            font-size 3rem
            line-height 3rem
            font-weight 600
            color #ccc
            text-align center
</style>
